import styled from "styled-components";
import { Input } from "components";

export const StyledInput = styled(Input)``;
